/** Vietnamese UI strings, keyed by the English text. */
export const vi: Record<string, string> = {
  // Navigation & common states
  Home: 'Trang chủ',
  Map: 'Bản đồ',
  Run: 'Chạy',
  Ranks: 'Xếp hạng',
  Profile: 'Hồ sơ',
  'Loading…': 'Đang tải…',
  'Something went wrong': 'Đã có lỗi xảy ra',
  'Couldn’t load this': 'Không tải được',
  'Try again': 'Thử lại',
  'You’re offline': 'Bạn đang offline',
  'This needs a connection. Your runs are still recorded and saved on this device.':
    'Cần có kết nối mạng. Các buổi chạy vẫn được ghi và lưu trên máy này.',
  Retry: 'Thử lại',

  // Profile
  'Finish your run first': 'Hãy kết thúc buổi chạy trước',
  'Edit profile': 'Sửa hồ sơ',
  'Run history': 'Lịch sử chạy',
  Connections: 'Kết nối',
  Notifications: 'Thông báo',
  Language: 'Ngôn ngữ',
  Privacy: 'Quyền riêng tư',
  'Sign out': 'Đăng xuất',
  'Could not save setting': 'Không lưu được cài đặt',
  'Hide start & end of my routes': 'Ẩn đoạn đầu và cuối lộ trình',
  'Other runners won’t see the first and last 200 m of your runs (protects your home). You always see your full route.':
    'Người khác sẽ không thấy 200 m đầu và cuối của buổi chạy (bảo vệ vị trí nhà bạn). Bạn vẫn luôn thấy toàn bộ lộ trình.',

  // Push notifications
  'Could not change notifications': 'Không đổi được cài đặt thông báo',
  'Push notifications': 'Thông báo đẩy',
  'On for this device. You’ll be notified when the app is closed.': 'Đang bật trên máy này. Bạn sẽ nhận thông báo cả khi đã đóng app.',
  'Get notified on this device even when the app is closed.': 'Nhận thông báo trên máy này cả khi đã đóng app.',
  'Turn off': 'Tắt',
  'Turn on': 'Bật',
  'Choose “Allow” in the notification prompt. On a Mac it can appear as a banner in the top-right corner — hover it, then Options → Allow.':
    'Chọn “Cho phép” trong hộp thoại thông báo. Trên Mac, hộp thoại có thể hiện ở góc trên bên phải — rê chuột vào rồi chọn Options → Allow.',
  'On iPhone, notifications work in the installed app: tap Share → “Add to Home Screen”, open Runner Wars from your home screen, then turn them on here.':
    'Trên iPhone, thông báo chỉ hoạt động trong app đã cài: bấm Chia sẻ → “Thêm vào MH chính”, mở Runner Wars từ màn hình chính rồi bật thông báo tại đây.',
  'This browser doesn’t support push notifications.': 'Trình duyệt này không hỗ trợ thông báo đẩy.',
  'Push notifications aren’t available on this server yet.': 'Máy chủ chưa hỗ trợ thông báo đẩy.',
  'Notifications are blocked for Runner Wars. Allow them in your phone or browser settings, then come back.':
    'Thông báo của Runner Wars đang bị chặn. Hãy cho phép trong cài đặt điện thoại hoặc trình duyệt rồi quay lại.',
  'Territory lost': 'Mất lãnh thổ',
  'A rival ran through your sectors.': 'Đối thủ vừa chạy qua ô của bạn.',
  'Kudos & comments': 'Kudos và bình luận',
  'Someone cheered or commented on your run.': 'Có người cổ vũ hoặc bình luận buổi chạy của bạn.',
  Events: 'Sự kiện',
  'Invitations, results and changes to events you’re in.': 'Lời mời, kết quả và thay đổi của sự kiện bạn tham gia.',
  Club: 'Câu lạc bộ',
  'Invites, join requests and members.': 'Lời mời, yêu cầu tham gia và thành viên.',
  'Strava imports': 'Nhập từ Strava',
  'A run arrived from Strava.': 'Có buổi chạy mới từ Strava.',

  // Home
  "Runner": "Runner",
  "Level {n}": "Cấp {n}",
  "{xp} XP total": "Tổng {xp} XP",
  "Territories": "Lãnh thổ",
  "Rank": "Hạng",
  "Distance": "Quãng đường",
  "Streak": "Chuỗi ngày",
  "day": "ngày",
  "days": "ngày",
  "Back to your run": "Quay lại buổi chạy",
  "Start run": "Bắt đầu chạy",
  "Run through a sector for 30 m to capture it.": "Chạy 30 m trong một ô để chiếm ô đó.",
  "Clubs →": "Câu lạc bộ →",
  "{members} members · ⬢ {territories} club territory": "{members} thành viên · ⬢ {territories} ô của CLB",
  "{n} join request(s) to review": "{n} yêu cầu tham gia cần duyệt",
  "Join or create a club": "Tham gia hoặc tạo CLB",
  "{n} invitation(s) waiting": "{n} lời mời đang chờ",
  "Conquer the city as a crew": "Cùng đồng đội chinh phục thành phố",
  "Open map →": "Mở bản đồ →",
  "Yours": "Của bạn",
  "Rivals": "Đối thủ",
  "Neutral": "Trống",
  "Territory stats unavailable offline.": "Không xem được thống kê lãnh thổ khi offline.",
  "Battle feed": "Diễn biến",
  "Feed unavailable.": "Không tải được diễn biến.",

  // Dates & formats
  "just now": "vừa xong",
  "{n}m ago": "{n} phút trước",
  "{n}h ago": "{n} giờ trước",
  "{n}d ago": "{n} ngày trước",
  "Morning Run": "Chạy buổi sáng",
  "Lunch Run": "Chạy buổi trưa",
  "Afternoon Run": "Chạy buổi chiều",
  "Evening Run": "Chạy buổi tối",
  "Night Run": "Chạy đêm",
  "Today at {time}": "Hôm nay lúc {time}",
  "Yesterday at {time}": "Hôm qua lúc {time}",
  "{date} at {time}": "{date} lúc {time}",

  // Events format
  "d": " ngày",
  "Starts in {time}": "Bắt đầu sau {time}",
  "{time} left": "Còn {time}",
  "Cancelled": "Đã huỷ",
  "Ended {date}": "Kết thúc {date}",
  "Each run {a}–{b} km": "Mỗi buổi chạy {a}–{b} km",
  "Each run at least {a} km": "Mỗi buổi chạy tối thiểu {a} km",
  "Each run at most {a} km": "Mỗi buổi chạy tối đa {a} km",
  "Pace between {a} and {b} /km": "Pace từ {a} đến {b} /km",
  "Pace no faster than {a} /km": "Pace không nhanh hơn {a} /km",
  "Pace no slower than {a} /km": "Pace không chậm hơn {a} /km",
  "{a} km in total": "Tổng {a} km",
  "{n} counted runs": "{n} buổi chạy hợp lệ",
  "{n} different sectors": "{n} ô khác nhau",
  "Territory held": "Ô đang giữ",
  "Sectors stolen": "Ô cướp được",
  "Most sectors held on the event map when it ends.": "Giữ nhiều ô nhất trên bản đồ sự kiện khi kết thúc.",
  "Most kilometres of runs that meet the event rules.": "Chạy nhiều km nhất với các buổi chạy đạt luật sự kiện.",
  "Most XP earned from runs that meet the event rules.": "Kiếm nhiều XP nhất từ các buổi chạy đạt luật sự kiện.",
  "Most sectors taken from other participants on the event map.": "Cướp nhiều ô nhất từ người tham gia khác (không tính đồng đội) trên bản đồ sự kiện.",
  "Teammates never take sectors from each other.": "Đồng đội không cướp ô của nhau.",
  "Team total": "Tổng của đội",
  "Team average per member": "Trung bình mỗi thành viên",

  // Battle feed
  "You": "Bạn",
  "Someone": "Ai đó",
  "{who} captured sector {key}": "{who} đã chiếm ô {key}",
  "You lost sector {key}": "Bạn mất ô {key}",
  "{who} ran {km} km": "{who} đã chạy {km} km",
  "{who} reached level {n}": "{who} đã lên cấp {n}",

  // Home cards
  "No battles yet. Be the first to capture Đà Nẵng.": "Chưa có trận nào. Hãy là người đầu tiên chiếm Đà Nẵng.",
  "Install Runner Wars": "Cài Runner Wars",
  "Full screen, faster start, works offline.": "Toàn màn hình, mở nhanh hơn, dùng được khi offline.",
  "Tap Share → “Add to Home Screen”.": "Bấm Chia sẻ → “Thêm vào MH chính”.",
  "Install": "Cài đặt",
  "Dismiss": "Đóng",
  "Notifications, {n} new": "Thông báo, {n} mới",
  "Strava connected": "Đã kết nối Strava",
  "New runs from your watch are imported automatically.": "Buổi chạy mới từ đồng hồ được nhập tự động.",
  "Auto-import is off — import runs manually.": "Đang tắt tự nhập — hãy nhập thủ công.",
  "Import": "Nhập",
  "Running with a watch?": "Chạy bằng đồng hồ?",
  "Connect Strava to bring your COROS, Garmin, Suunto or Apple Watch runs into the game.": "Kết nối Strava để đưa buổi chạy từ COROS, Garmin, Suunto hoặc Apple Watch vào game.",
  "🏁 Events — create a race for your crew": "🏁 Sự kiện — tạo cuộc đua cho nhóm của bạn",
  "You're invited": "Bạn được mời",
  "Your event · live": "Sự kiện của bạn · đang diễn ra",
  "Your event · soon": "Sự kiện của bạn · sắp diễn ra",
  "Event live": "Sự kiện đang diễn ra",
  "Next event": "Sự kiện sắp tới",
  "Run to get on the board →": "Chạy để lên bảng xếp hạng →",
  "{n} runners · join →": "{n} runner · tham gia →",
  "All events ›": "Tất cả sự kiện ›",

  // Sign in
  "Strava access was not granted.": "Bạn chưa cấp quyền cho Strava.",
  "Strava sign-in failed, please try again.": "Đăng nhập Strava thất bại, vui lòng thử lại.",
  "Run · Conquer · Compete": "Chạy · Chinh phục · Thi đấu",
  "Runner name": "Tên runner",
  "Email": "Email",
  "Password": "Mật khẩu",
  "You’re offline. Connect to sign in.": "Bạn đang offline. Hãy kết nối mạng để đăng nhập.",
  "Create runner": "Tạo tài khoản",
  "Sign in": "Đăng nhập",
  "Already running with us?": "Đã có tài khoản?",
  "New runner?": "Runner mới?",
  "Create an account": "Tạo tài khoản",
  "Password must be at least 8 characters": "Mật khẩu phải có ít nhất 8 ký tự",
  "Name must be at least 2 characters": "Tên phải có ít nhất 2 ký tự",
  "Name contains invalid characters": "Tên có ký tự không hợp lệ",
  "Invalid email": "Email không hợp lệ",
  "Enter a valid email": "Nhập email hợp lệ",
  "String must contain at most 32 character(s)": "Tối đa 32 ký tự",
  "String must contain at least 1 character(s)": "Không được để trống",
  "Pick a date": "Chọn ngày",
  "Pick a real birthday": "Ngày sinh không hợp lệ",
  "Whole centimetres": "Nhập số cm nguyên",
  "Height looks wrong": "Chiều cao không hợp lệ",
  "Weight looks wrong": "Cân nặng không hợp lệ",
  "Enter a valid phone number": "Số điện thoại không hợp lệ",
  "Upload a JPEG, PNG or WebP photo": "Hãy tải ảnh JPEG, PNG hoặc WebP",
  "Write something first": "Hãy viết gì đó trước",
  "Nothing to update": "Không có gì để cập nhật",
  "Wrong email or password": "Sai email hoặc mật khẩu",
  "Email is already registered": "Email đã được đăng ký",
  "This account signs in with Google or Facebook": "Tài khoản này đăng nhập bằng Google hoặc Facebook",
  "Request timed out": "Hết thời gian chờ",
  "Network unavailable": "Không có mạng",
  "Current password is wrong": "Mật khẩu hiện tại không đúng",
  "Use your own email address": "Hãy dùng email của bạn",
  "Add your email first, then set a password": "Hãy thêm email trước rồi đặt mật khẩu",
  "Photo is too large": "Ảnh quá lớn",
  "Too Many Requests": "Thao tác quá nhanh, vui lòng thử lại sau",
  "ThrottlerException: Too Many Requests": "Thao tác quá nhanh, vui lòng thử lại sau",

  // Misc pages
  "Sign-in failed": "Đăng nhập thất bại",
  "Google sign-in is unavailable right now": "Hiện chưa đăng nhập Google được",
  "Strava sign-in is unavailable right now": "Hiện chưa đăng nhập Strava được",
  "or": "hoặc",
  "Facebook sign-in is still loading, try again": "Facebook đang tải, vui lòng thử lại",
  "Continue with Facebook": "Tiếp tục với Facebook",
  "Signing in with Strava…": "Đang đăng nhập bằng Strava…",
  "Strava sign-in failed": "Đăng nhập Strava thất bại",
  "Please try again.": "Vui lòng thử lại.",
  "Nothing yet": "Chưa có gì",
  "Kudos, comments, lost sectors, club and event news will show up here.": "Kudos, bình luận, ô bị mất, tin CLB và sự kiện sẽ hiện ở đây.",
  "Older": "Cũ hơn",
  "Sync failed": "Đồng bộ thất bại",
  "Saved on device, waiting to sync": "Đã lưu trên máy, đang chờ đồng bộ",
  "No runs yet": "Chưa có buổi chạy nào",
  "Your runs, with distance, pace, XP and captures, will show up here.": "Các buổi chạy với quãng đường, pace, XP và ô chiếm được sẽ hiện ở đây.",
  "My runs": "Buổi chạy của tôi",
  "{name}’s runs": "Buổi chạy của {name}",
  "← Back": "← Quay lại",
  "‹ Back": "‹ Quay lại",
  "Load more": "Xem thêm",
  "Rank #{n}": "Hạng #{n}",
  "Runs": "Buổi chạy",
  "See all runs": "Xem tất cả buổi chạy",
  "best {n}": "cao nhất {n}",
  "Distance rank": "Hạng quãng đường",
  "Territory rank": "Hạng lãnh thổ",

  // Status
  "OFFLINE": "OFFLINE",
  "Run data is saved on this device and will sync when the connection returns.": "Dữ liệu chạy được lưu trên máy và sẽ đồng bộ khi có mạng lại.",
  "{n} runs waiting": "{n} buổi chạy đang chờ",
  "{n} run waiting": "{n} buổi chạy đang chờ",
  "SERVER UNREACHABLE": "MẤT KẾT NỐI MÁY CHỦ",
  "Runs are kept locally and retried automatically.": "Buổi chạy được giữ trên máy và tự gửi lại.",
  "Syncing {n} runs": "Đang đồng bộ {n} buổi chạy",
  "Syncing {n} run": "Đang đồng bộ {n} buổi chạy",
  "Waiting to sync {n} runs": "Đang chờ đồng bộ {n} buổi chạy",
  "Waiting to sync {n} run": "Đang chờ đồng bộ {n} buổi chạy",
  "VALID": "Hợp lệ",
  "SUSPICIOUS": "Nghi vấn",
  "REJECTED": "Bị loại",
  "PENDING": "Đang xử lý",
  "LOCAL": "Trên máy",
  "Close": "Đóng",
  "GPS off": "GPS tắt",
  "Searching GPS…": "Đang tìm GPS…",
  "GPS good": "GPS tốt",
  "GPS fair": "GPS khá",
  "GPS weak": "GPS yếu",
  "Location blocked": "Bị chặn vị trí",
  "GPS unavailable": "Không có GPS",

  // Run screen
  "Preparing GPS…": "Đang chuẩn bị GPS…",
  "Enable location for this site to run.": "Hãy bật vị trí cho trang này để chạy.",
  "Could not start": "Không bắt đầu được",
  "Could not finish": "Không kết thúc được",
  "Offline · saved locally": "Offline · đã lưu trên máy",
  "Following": "Đang theo dõi",
  "Follow me": "Theo tôi",
  "This browser cannot store data durably — keep the app open until the run is synced.": "Trình duyệt này không lưu dữ liệu bền vững — hãy giữ app mở cho đến khi buổi chạy được đồng bộ.",
  "Time": "Thời gian",
  "Pace now": "Pace hiện tại",
  "Avg pace": "Pace TB",
  "captured": "đã chiếm",
  "Km": "Km",
  "Paused": "Tạm dừng",
  "Resume": "Tiếp tục",
  "Pause": "Tạm dừng",
  "Finish": "Kết thúc",
  "Finish run": "Kết thúc buổi chạy",
  "Finish this run?": "Kết thúc buổi chạy?",
  "{n} sector(s) pending.": "{n} ô đang chờ.",
  "The server will validate it now.": "Máy chủ sẽ kiểm tra ngay bây giờ.",
  "You are offline — it will be validated when you reconnect.": "Bạn đang offline — buổi chạy sẽ được kiểm tra khi có mạng lại.",
  "Finish & save": "Kết thúc và lưu",
  "Keep running": "Chạy tiếp",
  "Discard run": "Bỏ buổi chạy",
  "Location is blocked": "Vị trí đang bị chặn",
  "Runner Wars needs your location to track runs.": "Runner Wars cần vị trí của bạn để ghi buổi chạy.",
  "Open Settings → Safari → Location → Allow, then reload.": "Mở Cài đặt → Safari → Vị trí → Cho phép, rồi tải lại.",
  "Tap the lock icon in the address bar → Permissions → Location → Allow, then reload.": "Bấm biểu tượng ổ khoá trên thanh địa chỉ → Quyền → Vị trí → Cho phép, rồi tải lại.",
  "Reload": "Tải lại",
  "Turn on location services and move outside with a clear view of the sky.": "Bật dịch vụ định vị và ra chỗ thoáng, nhìn thấy bầu trời.",
  "Start anyway": "Vẫn bắt đầu",
  "You’re outside {region}. A run mostly outside the game area doesn’t count.": "Bạn đang ở ngoài {region}. Buổi chạy có phần lớn quãng đường ngoài vùng chơi sẽ không được tính.",
  "Outside the game area": "Ngoài vùng chơi",
  "Owner only": "Chỉ owner",
  "Cities": "Thành phố",
  "All cities (incl. cities opened later)": "Tất cả thành phố (gồm cả thành phố mở sau)",
  "Only runs in these cities count. Each city has its own sectors on the event map.": "Chỉ tính run ở các thành phố này. Mỗi thành phố có ô riêng trên bản đồ event.",
  "Pick at least one city": "Chọn ít nhất một thành phố",
  "Unknown city": "Thành phố không hợp lệ",
  "All cities": "Tất cả thành phố",
  "In: {cities}": "Ở: {cities}",
  "Nationwide": "Toàn quốc",
  "Sponsors": "Nhà tài trợ",
  "Diamond sponsor": "Nhà tài trợ Kim cương",
  "Gold sponsor": "Nhà tài trợ Vàng",
  "Silver sponsor": "Nhà tài trợ Bạc",
  "Partner": "Đồng hành",
  "What they sponsor (e.g. finisher shirts)": "Tài trợ gì (vd: áo finisher)",
  "+ Add a sponsor": "+ Thêm nhà tài trợ",
  "Add brands in Owner → Brands first.": "Thêm nhãn hàng trong Owner → Brands trước.",
  "Google linked": "Đã liên kết Google",
  "You can now sign in with Google too.": "Từ giờ bạn đăng nhập được bằng Google.",
  "Google unlinked": "Đã huỷ liên kết Google",
  "Linked to {email}. You can sign in with Google or as before.": "Đã liên kết với {email}. Bạn đăng nhập được bằng Google hoặc như trước.",
  "Unlink Google": "Huỷ liên kết Google",
  "Link your Google account to sign in with one tap.": "Liên kết tài khoản Google để đăng nhập chỉ với một chạm.",
  "Set a password first: this is your only way to sign in": "Hãy đặt mật khẩu trước: đây là cách đăng nhập duy nhất của bạn",
  "Google sign-in doesn’t work inside Zalo or Messenger. Open this page in Safari or Chrome (⋯ → Open in browser).": "Không đăng nhập Google được trong Zalo hay Messenger. Hãy mở trang này bằng Safari hoặc Chrome (⋯ → Mở bằng trình duyệt).",
  "Show me how": "Xem cách làm",
  "This email already has a Runner Wars account. Sign in the way you usually do, then link Google in Profile → Email & password.": "Email này đã có tài khoản Runner Wars. Hãy đăng nhập như mọi khi, rồi liên kết Google trong Hồ sơ → Email & mật khẩu.",
  "This email already has a Runner Wars account. Sign in the way you usually do, then link Facebook in Profile → Email & password.": "Email này đã có tài khoản Runner Wars. Hãy đăng nhập như mọi khi, rồi liên kết Facebook trong Hồ sơ → Email & mật khẩu.",
  "This Google account already signs in to another Runner Wars account": "Tài khoản Google này đang dùng để đăng nhập một tài khoản Runner Wars khác",
  "Your account is already linked to a Google account": "Tài khoản của bạn đã liên kết với một tài khoản Google",
  "Hoàng Sa Archipelago": "Quần đảo Hoàng Sa",
  "Trường Sa Archipelago": "Quần đảo Trường Sa",
  "East Sea": "Biển Đông",
  "Weak GPS. Move to an open area for accurate tracking.": "GPS yếu. Hãy ra chỗ thoáng để ghi chính xác.",
  "Start": "Bắt đầu",
  "Start (waiting for GPS)": "Bắt đầu (đang chờ GPS)",
  "Keep this screen open while running.": "Giữ màn hình này mở khi chạy.",
  "iOS pauses GPS when the screen is locked.": "iOS tạm dừng GPS khi khoá màn hình.",
  "Enemy": "Đối thủ",
  "Outside game area": "Ngoài khu vực game",

  // Run detail
  "Validated by the server. XP and territories are yours.": "Đã được máy chủ xác nhận. XP và lãnh thổ là của bạn.",
  "This run looks unusual. It is saved, but does not count for XP, territories or rankings.": "Buổi chạy có dấu hiệu bất thường. Vẫn được lưu nhưng không tính XP, lãnh thổ hay xếp hạng.",
  "This run was rejected by anti-cheat and does not count.": "Buổi chạy bị hệ thống chống gian lận loại và không được tính.",
  "This run is outside the game area, so it does not count.": "Buổi chạy nằm ngoài vùng chơi nên không được tính.",
  "Most of the run is outside the game area": "Phần lớn buổi chạy nằm ngoài vùng chơi",
  "Waiting for validation.": "Đang chờ kiểm tra.",
  "Run saved": "Đã lưu buổi chạy",
  "The server refused this run: {error}": "Máy chủ từ chối buổi chạy: {error}",
  "unknown error": "lỗi không xác định",
  "Offline. Run data saved locally — it will sync and be validated when the connection returns.": "Offline. Dữ liệu đã lưu trên máy — sẽ đồng bộ và kiểm tra khi có mạng lại.",
  "Uploading and validating…": "Đang tải lên và kiểm tra…",
  "Waiting to sync…": "Đang chờ đồng bộ…",
  "Run not found": "Không tìm thấy buổi chạy",
  "No route recorded": "Không có lộ trình",
  "Back": "Quay lại",
  "Crossed": "Đã đi qua",
  "Captured": "Đã chiếm",
  "Imported": "Đã nhập",
  "File": "File",
  "Run complete": "Hoàn thành buổi chạy",
  "Territory conquered": "Ô chinh phục được",
  "Territories conquered": "Ô chinh phục được",
  "Moving time": "Thời gian chạy",
  "XP earned": "XP nhận được",
  "Sectors crossed": "Ô đã đi qua",
  "View on Strava": "Xem trên Strava",
  "🔒 This runner hides the first and last 200 m of their routes.": "🔒 Runner này ẩn 200 m đầu và cuối lộ trình.",
  "Counted for this event": "Được tính cho sự kiện này",
  "Sectors": "Ô",
  "held": "giữ",
  "XP breakdown": "Chi tiết XP",
  "Validation notes": "Ghi chú kiểm tra",
  "View map": "Xem bản đồ",
  "Rankings": "Xếp hạng",
  "Splits": "Từng km",
  "Run distance": "Quãng đường",
  "Completed run": "Hoàn thành buổi chạy",
  "First run of the day": "Buổi chạy đầu tiên trong ngày",

  // XP lines
  "{km} km validated": "{km} km hợp lệ",
  "{n} territory captured": "Chiếm {n} ô",
  "{n} territories captured": "Chiếm {n} ô",
  "Run completed": "Hoàn thành buổi chạy",

  // Kudos & comments
  "Could not give kudos": "Không gửi được kudos",
  "Kudos given": "Đã gửi kudos",
  "Give kudos": "Gửi kudos",
  "kudo": "kudos",
  "kudos": "kudos",
  "Kudos": "Kudos",
  "Could not post the comment": "Không đăng được bình luận",
  "Could not delete": "Không xoá được",
  "Invalid comment": "Bình luận không hợp lệ",
  "Delete comment": "Xoá bình luận",
  "Delete": "Xoá",
  "No comments yet — say something nice.": "Chưa có bình luận — hãy nói điều gì đó dễ thương.",
  "Add a comment…": "Viết bình luận…",
  "Post": "Đăng",
  "Comments": "Bình luận",
  "pace": "pace",
  "time": "thời gian",

  // Map
  "Loading game region…": "Đang tải khu vực game…",
  "Allow location for this site in your browser settings.": "Hãy cho phép vị trí cho trang này trong cài đặt trình duyệt.",
  "Finding you…": "Đang tìm vị trí của bạn…",
  "Waiting for GPS.": "Đang chờ GPS.",
  "{n} sectors": "{n} ô",
  "Runners": "Runner",
  "Clubs": "CLB",
  "Center on my location": "Về vị trí của tôi",
  "Dark map": "Bản đồ tối",
  "Light map": "Bản đồ sáng",

  // Territory
  "Loading map…": "Đang tải bản đồ…",
  "Territory": "Lãnh thổ",
  "Sector": "Ô",
  "Couldn’t load this sector right now.": "Hiện không tải được ô này.",
  "Held since {time}": "Giữ từ {time}",
  "Unclaimed. Run 30 m inside this sector with good GPS to capture it.": "Chưa ai chiếm. Chạy 30 m trong ô này với GPS tốt để chiếm.",
  "Run through it to take it from {name}. ⚔️": "Chạy qua để cướp ô từ {name}. ⚔️",
  "History": "Lịch sử",

  // Rankings
  "sectors": "ô",
  "🏁 Events & Hall of Fame": "🏁 Sự kiện & Bảng vàng",
  "No rankings yet": "Chưa có xếp hạng",
  "Only validated runs count. Finish a run to claim the top spot.": "Chỉ tính các buổi chạy hợp lệ. Hãy hoàn thành một buổi chạy để giành vị trí đầu.",
  "Your rank": "Hạng của bạn",
  "Finish a validated run to get ranked.": "Hoàn thành một buổi chạy hợp lệ để được xếp hạng.",
  "No clubs yet": "Chưa có CLB",
  "Create a club and conquer the city as a crew.": "Tạo CLB và cùng đồng đội chinh phục thành phố.",
  "Your club": "CLB của bạn",
  "{n} member": "{n} thành viên",
  "{n} members": "{n} thành viên",
  "{name} (you)": "{name} (bạn)",

  // Clubs
  "Welcome to the club!": "Chào mừng bạn vào CLB!",
  "Request cancelled": "Đã huỷ yêu cầu",
  "Request sent — the owner will review it": "Đã gửi yêu cầu — chủ CLB sẽ duyệt",
  "Club created": "Đã tạo CLB",
  "Run together. Every sector your members hold is club territory.": "Cùng nhau chạy. Mọi ô thành viên đang giữ là lãnh thổ của CLB.",
  "{n} to review": "{n} cần duyệt",
  "You’re running solo": "Bạn đang chạy một mình",
  "Join a club below, or start your own crew.": "Tham gia một CLB bên dưới, hoặc tự lập nhóm.",
  "Create a club": "Tạo CLB",
  "Invitations": "Lời mời",
  "Waiting for approval": "Đang chờ duyệt",
  "Cancel": "Huỷ",
  "DELETE": "XÓA",
  "Delete account": "Xóa tài khoản",
  "Delete your account?": "Xóa tài khoản của bạn?",
  "This permanently deletes your profile, runs, XP, awards and connections. Your sectors go back to neutral. This cannot be undone.": "Hồ sơ, các buổi chạy, XP, giải thưởng và kết nối của bạn sẽ bị xóa vĩnh viễn. Các ô bạn đang giữ trở về trạng thái trống. Không thể hoàn tác.",
  "Clubs and events you own are handed over to another member or organiser so the others can keep playing.": "Câu lạc bộ và sự kiện bạn sở hữu sẽ được chuyển cho thành viên hoặc ban tổ chức khác để mọi người vẫn tiếp tục chơi.",
  "Type {word} to confirm": "Gõ {word} để xác nhận",
  "Delete my account": "Xóa tài khoản của tôi",
  "Your account was deleted": "Tài khoản của bạn đã được xóa",
  "The game owner’s account can’t be deleted": "Không thể xóa tài khoản của chủ trò chơi",
  "Find a club": "Tìm CLB",
  "Search clubs by name": "Tìm CLB theo tên",
  "Search clubs": "Tìm CLB",
  "No clubs found": "Không tìm thấy CLB",
  "Try another name, or create it yourself.": "Thử tên khác, hoặc tự tạo CLB.",
  "Be the first to start a club in Đà Nẵng.": "Hãy là người đầu tiên lập CLB ở Đà Nẵng.",
  "Requested": "Đã gửi yêu cầu",
  "Join": "Tham gia",
  "Invited by {name}": "{name} mời",
  "Invitation": "Lời mời",
  "leave your club to accept": "rời CLB hiện tại để nhận lời",
  "Invalid": "Không hợp lệ",
  "Create club": "Tạo CLB",
  "Name": "Tên",
  "Description (optional)": "Mô tả (không bắt buộc)",
  "Create": "Tạo",

  // Club detail
  "Member approved": "Đã duyệt thành viên",
  "You left the club": "Bạn đã rời CLB",
  "Member removed": "Đã xoá thành viên",
  "Ownership transferred": "Đã chuyển quyền chủ CLB",
  "New invite link created": "Đã tạo link mời mới",
  "Invitation sent": "Đã gửi lời mời",
  "Join {name} on Runner Wars": "Tham gia {name} trên Runner Wars",
  "Invite link copied": "Đã sao chép link mời",
  "Owner": "Chủ CLB",
  "Members": "Thành viên",
  "Club XP": "XP CLB",
  "Invite runners": "Mời runner",
  "Share invite link": "Chia sẻ link mời",
  "Request pending · Cancel": "Đang chờ duyệt · Huỷ",
  "Accept invitation": "Nhận lời mời",
  "Request to join": "Xin tham gia",
  "Join requests": "Yêu cầu tham gia",
  "Approve": "Duyệt",
  "Invited, waiting for answer:": "Đã mời, đang chờ trả lời:",
  "(you)": "(bạn)",
  "Manage {name}": "Quản lý {name}",
  "Reset invite link": "Tạo lại link mời",
  "Transfer ownership first": "Hãy chuyển quyền chủ CLB trước",
  "Tap ⋯ next to a member to make them owner.": "Bấm ⋯ cạnh một thành viên để chuyển quyền chủ.",
  "Disband club": "Giải tán CLB",
  "Leave club": "Rời CLB",
  "Manage member": "Quản lý thành viên",
  "Make owner": "Chuyển quyền chủ",
  "Remove from club": "Xoá khỏi CLB",
  "Search runners by name": "Tìm runner theo tên",
  "Search runners": "Tìm runner",
  "Type at least 2 letters": "Nhập ít nhất 2 ký tự",
  "No runners found": "Không tìm thấy runner",
  "Member": "Thành viên",
  "In a club": "Đã có CLB",
  "Invited": "Đã mời",
  "Invite": "Mời",

  // Join club
  "Could not join": "Không tham gia được",
  "Can’t join": "Không thể tham gia",
  "Browse clubs": "Xem các CLB",
  "Joining club…": "Đang tham gia CLB…",

  // Events list
  "+ Create": "+ Tạo",
  "Races organised by runners — each with its own map, teams and rules.": "Các cuộc đua do runner tổ chức — mỗi cuộc có bản đồ, đội và luật riêng.",
  "Discover": "Khám phá",
  "Mine": "Của tôi",
  "Hall of Fame": "Bảng vàng",
  "Live now": "Đang diễn ra",
  "Coming up": "Sắp diễn ra",
  "No public events yet": "Chưa có sự kiện công khai",
  "Create one and invite your running friends.": "Hãy tạo một sự kiện và mời bạn chạy.",
  "Joined or organised": "Đã tham gia hoặc tổ chức",
  "You're not in any event": "Bạn chưa tham gia sự kiện nào",
  "Join one from Discover, or create your own.": "Tham gia từ mục Khám phá, hoặc tự tạo.",
  "Champions": "Nhà vô địch",
  "No finished events yet": "Chưa có sự kiện nào kết thúc",
  "Official": "Chính thức",
  "Private": "Riêng tư",
  "{n} runner": "{n} runner",
  "{n} runners": "{n} runner",
  "{n} teams": "{n} đội",
  "by {name}": "bởi {name}",
  "Joined": "Đã tham gia",
  "Organiser": "Ban tổ chức",
  "Team: {name}": "Đội: {name}",

  // Create event
  "Event updated": "Đã cập nhật sự kiện",
  "Event created": "Đã tạo sự kiện",
  "Add teams and invite runners.": "Hãy thêm đội và mời runner.",
  "Could not save the event": "Không lưu được sự kiện",
  "Could not create the event": "Không tạo được sự kiện",
  "Pace must look like 5:30": "Pace phải có dạng 5:30",
  "Invalid event": "Sự kiện không hợp lệ",
  "Edit event": "Sửa sự kiện",
  "New event": "Sự kiện mới",
  "You'll be the organiser. Every event has its own map, so it never clashes with other events.": "Bạn sẽ là ban tổ chức. Mỗi sự kiện có bản đồ riêng nên không ảnh hưởng sự kiện khác.",
  "The event is live: how to win, the start and the run rules are locked. You can still change the name, description, end date and limits.": "Sự kiện đang diễn ra: cách thắng, giờ bắt đầu và luật chạy đã bị khoá. Bạn vẫn đổi được tên, mô tả, ngày kết thúc và giới hạn.",
  "Everything can change until the event starts. Runners who already joined see the new rules right away.": "Có thể đổi mọi thứ cho đến khi sự kiện bắt đầu. Runner đã tham gia sẽ thấy luật mới ngay.",
  "How to win": "Cách thắng",
  "Team score": "Điểm đội",
  "Big teams have an edge: every member adds to the team.": "Đội đông có lợi: mỗi thành viên đều cộng điểm cho đội.",
  "Fair for small teams: the team scores its members’ average.": "Công bằng cho đội nhỏ: điểm đội là trung bình của thành viên.",
  "Who can join": "Ai được tham gia",
  "Public — anyone can find and join": "Công khai — ai cũng tìm và tham gia được",
  "Private — invite or link only": "Riêng tư — chỉ qua lời mời hoặc link",
  "Starts": "Bắt đầu",
  "Ends": "Kết thúc",
  "Which runs count": "Buổi chạy nào được tính",
  "Min km / run": "Km tối thiểu / buổi",
  "Max km / run": "Km tối đa / buổi",
  "Fastest pace": "Pace nhanh nhất",
  "Slowest pace": "Pace chậm nhất",
  "e.g. {v}": "vd. {v}",
  "Only validated runs started after a runner joins are counted. Leave blank for no limit.": "Chỉ tính buổi chạy hợp lệ bắt đầu sau khi runner tham gia. Để trống nếu không giới hạn.",
  "To finish (and win awards)": "Để hoàn thành (và nhận giải)",
  "Total km": "Tổng km",
  "Max participants": "Số người tối đa",
  "Unlimited": "Không giới hạn",
  "Save changes": "Lưu thay đổi",
  "Create event": "Tạo sự kiện",

  // Event detail
  "Action failed": "Thao tác thất bại",
  "● Live": "● Đang diễn ra",
  "Upcoming": "Sắp diễn ra",
  "Final results": "Kết quả chung cuộc",
  "You're in {name}!": "Bạn đã tham gia {name}!",
  "Team changed": "Đã đổi đội",
  "You left the event": "Bạn đã rời sự kiện",
  "Invitation declined": "Đã từ chối lời mời",
  "You're in": "Bạn đã tham gia",
  "Team": "Đội",
  "{n} runs": "{n} buổi chạy",
  "✓ Qualified": "✓ Đủ điều kiện",
  "Not yet qualified": "Chưa đủ điều kiện",
  "Switch team": "Đổi đội",
  "Leave? Your sectors leave the event map.": "Rời đi? Các ô của bạn sẽ bị xoá khỏi bản đồ sự kiện.",
  "Leave": "Rời",
  "Stay": "Ở lại",
  "Leave event": "Rời sự kiện",
  "✉️ You've been invited to this event": "✉️ Bạn được mời tham gia sự kiện này",
  "Pick your team": "Chọn đội",
  "Club teams are for that club's members.": "Đội CLB chỉ dành cho thành viên CLB đó.",
  "Event is full": "Sự kiện đã đủ người",
  "Join now": "Tham gia ngay",
  "Join event": "Tham gia sự kiện",
  "Runs started after you join will count.": "Các buổi chạy bắt đầu sau khi tham gia sẽ được tính.",
  "Decline invitation": "Từ chối lời mời",
  "Not started yet": "Chưa bắt đầu",
  "No runners yet": "Chưa có runner",
  "Not qualified": "Chưa đủ điều kiện",
  "Delete this run": "Xoá buổi chạy này",
  "Unfinished run": "Buổi chạy chưa kết thúc",
  "How to install and play": "Hướng dẫn cài đặt & cách chơi",
  "A new version is available": "Có phiên bản mới",
  "Reload to get the latest version. Your progress is kept.": "Tải lại để dùng phiên bản mới nhất. Tiến trình của bạn vẫn được giữ.",
  "Update": "Cập nhật",
  "Later": "Để sau",
  "See how to install": "Xem cách cài",
  "New here? Read the 2-minute guide": "Mới chơi? Xem hướng dẫn 2 phút",
  "Install the game, capture sectors, use your watch.": "Cài game, chiếm ô đất, dùng đồng hồ.",
  "Guide & help": "Hướng dẫn & trợ giúp",
  "How to allow location": "Cách bật vị trí",
  "Step-by-step guide with pictures": "Hướng dẫn từng bước có hình",
  "How events, teams and qualifying work": "Luật sự kiện, đội và điều kiện xếp hạng",
  "This run was started but never finished, so it earned nothing. It also blocks uploading or importing another run at the same time.": "Buổi chạy này đã bắt đầu nhưng chưa bao giờ kết thúc nên không được tính gì. Nó cũng chặn việc upload hoặc nhập buổi chạy khác trong cùng khoảng thời gian.",
  "It was never finished and earned nothing. Deleting it frees its time, so the same session can be uploaded or imported.": "Buổi này chưa kết thúc và chưa được tính gì. Xoá đi để có thể upload hoặc nhập lại buổi chạy cùng giờ.",
  "Delete that run first to upload this file.": "Hãy xoá buổi chạy đó trước rồi upload lại file.",
  "You already have a run at this time": "Bạn đã có một buổi chạy vào thời gian này",
  "Already imported": "Buổi chạy này đã được nhập",
  "Delete this run?": "Xoá buổi chạy này?",
  "Delete run": "Xoá buổi chạy",
  "Run deleted": "Đã xoá buổi chạy",
  "Everything it earned is taken back: XP, distance, its place in events, and its sectors, which go back to whoever held them before.": "Mọi thứ buổi chạy này mang lại sẽ bị thu hồi: XP, quãng đường, kết quả trong sự kiện và các ô đất (trả lại cho người giữ trước đó).",
  "Your Strava runs open next, so you can import it again.": "Sau khi xoá, danh sách buổi chạy Strava sẽ mở ra để bạn nhập lại.",
  "You can upload the file again.": "Bạn có thể tải file lên lại.",
  "A run recorded in the app cannot be recovered.": "Buổi chạy ghi bằng app sẽ không khôi phục lại được.",
  "Runner moved": "Đã chuyển đội cho runner",
  "Balance teams": "Cân bằng đội",
  "Move a runner to another team. Their sectors move with them.": "Chuyển runner sang đội khác. Các ô họ đang giữ cũng chuyển theo.",
  "Team of {name}": "Đội của {name}",
  "{name}: the organisers moved you to another team": "{name}: ban tổ chức đã chuyển bạn sang đội khác",
  "{have}/{need} counted runs": "{have}/{need} buổi chạy được tính",
  "{have}/{need} km in total": "{have}/{need} km tổng",
  "{have}/{need} different sectors": "{have}/{need} ô khác nhau",
  "No teams": "Không có đội",
  "This event is every runner for themselves.": "Sự kiện này mỗi runner tự thi đấu.",
  "{scoring} of {rule}. Tap a team to see its runners.": "{scoring} theo {rule}. Bấm vào đội để xem runner.",
  "Team leaderboard": "Bảng xếp hạng đội",
  "Team rank": "Hạng đội",
  "avg": "TB",
  "Overall #{n}": "Tổng #{n}",
  "Nobody has picked this team so far.": "Chưa ai chọn đội này.",
  "Map unavailable": "Không có bản đồ",
  "This event is in another region.": "Sự kiện này ở khu vực khác.",
  "This event's own map — only participants' runs count here.": "Bản đồ riêng của sự kiện — chỉ tính buổi chạy của người tham gia.",
  "Coloured by team.": "Tô màu theo đội.",
  "held by your team": "ô đội bạn giữ",
  "held by you": "ô bạn giữ",
  "{n} taken.": "{n} ô đã bị chiếm.",
  "You can change the rules until the event starts.": "Bạn có thể đổi luật cho đến khi sự kiện bắt đầu.",
  "Rules are locked while the event is live.": "Luật bị khoá khi sự kiện đang diễn ra.",
  "Edit": "Sửa",
  "Teams": "Đội",
  "Runs that count": "Buổi chạy được tính",
  "Validated runs started after you joined, during the event": "Buổi chạy hợp lệ bắt đầu sau khi bạn tham gia, trong thời gian sự kiện",
  "To qualify for awards": "Điều kiện nhận giải",
  "max {n} runners": "tối đa {n} runner",
  "Organisers": "Ban tổ chức",
  "Organiser tools": "Công cụ ban tổ chức",
  "Edit event ›": "Sửa sự kiện ›",
  "Share": "Chia sẻ",
  "Make co-organiser": "Thêm làm đồng tổ chức",
  "club": "CLB",
  "Remove {name}": "Xoá {name}",
  "No teams: everyone runs for themselves. Add teams before runners join.": "Không có đội: mỗi người tự chạy. Hãy thêm đội trước khi runner tham gia.",
  "New team name": "Tên đội mới",
  "Add": "Thêm",
  "…or add a club as a team": "…hoặc thêm CLB làm đội",
  "End now and freeze the results?": "Kết thúc ngay và chốt kết quả?",
  "Cancel this event for everyone?": "Huỷ sự kiện này với mọi người?",
  "Yes": "Có",
  "No": "Không",
  "End now": "Kết thúc ngay",
  "Cancel event": "Huỷ sự kiện",
  "Team added": "Đã thêm đội",
  "Team removed": "Đã xoá đội",
  "Co-organiser added": "Đã thêm đồng tổ chức",
  "Event ended — results are final": "Sự kiện đã kết thúc — kết quả đã chốt",
  "Event cancelled": "Đã huỷ sự kiện",
  "Rules": "Luật",

  // Live toasts
  "Run restored": "Đã khôi phục buổi chạy",
  "Your unfinished run was recovered. Resume or finish it.": "Buổi chạy dở đã được khôi phục. Hãy chạy tiếp hoặc kết thúc.",
  "{name} captured a territory": "{name} đã chiếm một ô",
  "Sector {key}": "Ô {key}",
  "Territory lost!": "Mất lãnh thổ!",
  "{name} took sector {key}. Take it back!": "{name} đã cướp ô {key}. Lấy lại ngay!",
  "A rival": "Một đối thủ",
  "{name} is nearby": "{name} đang ở gần",
  "{n} sector(s) away": "cách {n} ô",
  "{name} started a run": "{name} bắt đầu chạy",
  "{name} finished {km} km": "{name} đã chạy xong {km} km",
  "🏃‍♂️ {name} gave you kudos": "🏃‍♂️ {name} đã gửi kudos cho bạn",
  "💬 {name} commented on your run": "💬 {name} đã bình luận buổi chạy của bạn",
  "Invitation: {name}": "Lời mời: {name}",
  "{name} invited you — open Events to join.": "{name} đã mời bạn — mở Sự kiện để tham gia.",
  "{name} has ended": "{name} đã kết thúc",
  "🏆 Champion: {name}": "🏆 Vô địch: {name}",
  "Results are final.": "Kết quả đã chốt.",
  "{name}: the rules changed": "{name}: luật đã thay đổi",
  "Open the event to see the new rules.": "Mở sự kiện để xem luật mới.",
  "{name} was cancelled": "{name} đã bị huỷ",
  "You were removed from {name}": "Bạn đã bị xoá khỏi {name}",
  "Run imported from Strava · {km} km": "Đã nhập buổi chạy từ Strava · {km} km",
  "{n} sector(s) captured": "chiếm {n} ô",
  "Status: {status}": "Trạng thái: {status}",
  "{club} invited you to join": "{club} mời bạn tham gia",
  "{name} wants to join {club}": "{name} muốn tham gia {club}",
  "You’re now a member of {club}": "Bạn đã là thành viên của {club}",
  "{club} declined your request": "{club} đã từ chối yêu cầu của bạn",
  "{name} joined {club}": "{name} đã tham gia {club}",
  "{name} left {club}": "{name} đã rời {club}",
  "Level {n}!": "Cấp {n}!",
  "You leveled up.": "Bạn đã lên cấp.",
  "Territory captured!": "Đã chiếm ô!",
  "Sector {key} · confirmed when you finish": "Ô {key} · được xác nhận khi bạn kết thúc",
  "Sign in again to sync your runs": "Hãy đăng nhập lại để đồng bộ buổi chạy",

  // Connections
  "Allow “View data about your activities” to import runs": "Hãy cho phép “Xem dữ liệu hoạt động” để nhập buổi chạy",
  "Could not connect Strava": "Không kết nối được Strava",
  "Strava access was not granted": "Bạn chưa cấp quyền Strava",
  "Strava disconnected": "Đã ngắt kết nối Strava",
  "Import failed": "Nhập thất bại",
  "Auto-import new runs": "Tự nhập buổi chạy mới",
  "Runs you upload to Strava appear here automatically.": "Buổi chạy bạn tải lên Strava sẽ tự xuất hiện ở đây.",
  "Disconnect": "Ngắt kết nối",
  "Import runs from your watch (COROS, Garmin, Suunto, Apple Watch) through Strava.": "Nhập buổi chạy từ đồng hồ (COROS, Garmin, Suunto, Apple Watch) qua Strava.",
  "Coming soon": "Sắp có",
  "Soon": "Sắp có",
  "Upload a run file": "Tải file buổi chạy",
  "GPX, TCX or FIT from any watch · last 7 days": "GPX, TCX hoặc FIT từ mọi đồng hồ · trong 7 ngày gần nhất",
  "Upload": "Tải lên",
  "How to export from your watch": "Cách xuất dữ liệu từ đồng hồ",
  "COROS app → activity → ⋯ → Export data → FIT/GPX.": "App COROS → hoạt động → ⋯ → Export data → FIT/GPX.",
  "Garmin Connect (web) → activity → ⚙ → Export Original (FIT) or GPX.": "Garmin Connect (web) → hoạt động → ⚙ → Export Original (FIT) hoặc GPX.",
  "Suunto app → activity → ⋯ → Export GPX.": "App Suunto → hoạt động → ⋯ → Export GPX.",
  "use an app like HealthFit or RunGap to export the workout as FIT/GPX (Apple Health has no web API).": "dùng app như HealthFit hoặc RunGap để xuất bài tập ra FIT/GPX (Apple Health không có web API).",
  "Or connect Strava above — most watches sync there automatically.": "Hoặc kết nối Strava ở trên — hầu hết đồng hồ tự đồng bộ lên đó.",

  // Strava import
  "Import runs": "Nhập buổi chạy",
  "Runs from the last 7 days. Imported runs are validated like live runs and can capture territory.": "Buổi chạy trong 7 ngày gần nhất. Buổi chạy được nhập sẽ được kiểm tra như chạy trực tiếp và có thể chiếm ô.",
  "No recent runs on Strava": "Không có buổi chạy gần đây trên Strava",
  "View": "Xem",

  // Edit profile & account
  "Profile saved": "Đã lưu hồ sơ",
  "Could not save profile": "Không lưu được hồ sơ",
  "Could not update photo": "Không cập nhật được ảnh",
  "Change photo": "Đổi ảnh",
  "Add photo": "Thêm ảnh",
  "Remove": "Xoá",
  "Bio": "Giới thiệu",
  "{n}/150 · shown on your public profile": "{n}/150 · hiện trên hồ sơ công khai",
  "Colour": "Màu",
  "How other runners see you on the map. You always see yourself in green.": "Màu người khác thấy bạn trên bản đồ. Bạn luôn thấy mình màu xanh.",
  "Health": "Sức khoẻ",
  "Private — only you can see this.": "Riêng tư — chỉ bạn thấy.",
  "Gender": "Giới tính",
  "Male": "Nam",
  "Female": "Nữ",
  "Other": "Khác",
  "Birthday": "Ngày sinh",
  "Height (cm)": "Chiều cao (cm)",
  "Weight (kg)": "Cân nặng (kg)",
  "Contact": "Liên hệ",
  "Country": "Quốc gia",
  "Address": "Địa chỉ",
  "Phone": "Điện thoại",
  "Email & password": "Email & mật khẩu",
  "Save": "Lưu",
  "Country code": "Mã quốc gia",
  "Email updated": "Đã cập nhật email",
  "Use it to sign in from now on.": "Từ giờ hãy dùng email này để đăng nhập.",
  "Your account has no email yet (you sign in with Strava, Google or Facebook). Add one to also sign in with a password.": "Tài khoản chưa có email (bạn đăng nhập bằng Strava, Google hoặc Facebook). Thêm email để có thể đăng nhập bằng mật khẩu.",
  "Current password": "Mật khẩu hiện tại",
  "Save email": "Lưu email",
  "Password changed": "Đã đổi mật khẩu",
  "Password set": "Đã đặt mật khẩu",
  "Other devices were signed out.": "Các thiết bị khác đã bị đăng xuất.",
  "Change password": "Đổi mật khẩu",
  "Set a password": "Đặt mật khẩu",
  "Add your email above first, then set a password.": "Hãy thêm email ở trên trước, rồi đặt mật khẩu.",
  "New password": "Mật khẩu mới",
  "Repeat new password": "Nhập lại mật khẩu mới",
  "Passwords don’t match": "Mật khẩu không khớp",
  "Set password": "Đặt mật khẩu",

  // More
  "Back to sign in": "Quay lại đăng nhập",

  // Comment replies & kudos
  "Reply": "Trả lời",
  "Replying to {name}": "Đang trả lời {name}",
  "Cancel reply": "Huỷ trả lời",
  "Write a reply…": "Viết câu trả lời…",
  "↩️ {name} replied to your comment": "↩️ {name} đã trả lời bình luận của bạn",
  "🏃‍♂️ {name} gave kudos to your comment": "🏃‍♂️ {name} đã gửi kudos cho bình luận của bạn",
  "Yours, lost": "Ô bạn bị mất",
  "⚔️ You lost 1 sector here": "⚔️ Bạn mất 1 ô ở buổi chạy này",
  "⚔️ You lost {n} sectors here": "⚔️ Bạn mất {n} ô ở buổi chạy này",
  "Marked red on the map. Run through them to take them back!": "Các ô màu đỏ trên bản đồ. Chạy qua để lấy lại nhé!",
  "You vs {name}": "Bạn và {name}",
  "Taken from": "Cướp từ",
  "Unclaimed sectors": "Ô trống",
  "Show": "Xem",
  "Showing": "Đang xem",
  "No rivals yet. Take a sector someone else holds — or lose one — and they show up here.": "Chưa có đối thủ. Khi bạn cướp ô của ai đó — hoặc bị cướp — họ sẽ hiện ở đây.",
  "See all {n} rivals": "Xem tất cả {n} đối thủ",
  "Sectors you took from each runner, and they took from you.": "Số ô bạn đã cướp của từng người, và họ đã cướp của bạn.",
  "No rivals yet": "Chưa có đối thủ",
  "You took {a} · They took {b}": "Bạn cướp {a} · Bị cướp {b}",
  "{n} to retake": "{n} ô cần lấy lại",
  "You vs": "Bạn đấu với",
  "Sectors you took": "Ô bạn đã cướp",
  "Sectors they took": "Ô bạn bị cướp",
  "Show on map": "Xem trên bản đồ",
  "To take back · {n}": "Cần lấy lại · {n}",
  "{name} holds none of your sectors right now.": "{name} hiện không giữ ô nào của bạn.",
  "Yours, taken from them · {n}": "Bạn đang giữ của họ · {n}",
  "You hold none of their sectors right now.": "Bạn hiện không giữ ô nào của họ.",
  "1 sector to take back": "1 ô cần lấy lại",
  "{n} sectors to take back": "{n} ô cần lấy lại",
  "Clear": "Bỏ",
  "Edit club": "Sửa CLB",
  "Club updated": "Đã cập nhật CLB",
  "Change logo": "Đổi logo",
  "Add logo": "Thêm logo",
  "Remove logo": "Xoá logo",
  "Could not update logo": "Không cập nhật được logo",
  "Could not read that image": "Không đọc được ảnh này",
  "Optional · square images work best": "Không bắt buộc · ảnh vuông đẹp nhất",
  "Only the club owner can edit the club": "Chỉ chủ CLB mới sửa được CLB",
  "Zalo group announcements": "Thông báo nhóm Zalo",
  "Connected": "Đã kết nối",
  "Waiting for group": "Chờ kết nối nhóm",
  "A Zalo bot posts the event, new teams, the start, every counted run and the winners to your runners’ Zalo group. Create a bot in the Zalo Bot Creator app, then paste its token here.": "Bot Zalo sẽ đăng thông tin sự kiện, đội mới, giờ bắt đầu, từng buổi chạy được tính và người chiến thắng vào nhóm Zalo của các runner. Tạo bot trong ứng dụng Zalo Bot Creator rồi dán token vào đây.",
  "How?": "Cách tạo?",
  "Bot token from Zalo Bot Creator": "Token bot từ Zalo Bot Creator",
  "Save bot": "Lưu bot",
  "Bot": "Bot",
  "token …{hint}": "token …{hint}",
  "Webhook set on the bot automatically": "Đã tự cấu hình webhook cho bot",
  "Set the webhook on your bot": "Cấu hình webhook cho bot",
  "Zalo did not accept it automatically. Set it yourself (setWebhook) with this URL and secret token.": "Zalo chưa nhận cấu hình tự động. Hãy tự cấu hình webhook (setWebhook) với URL và secret token dưới đây.",
  "Webhook URL": "Webhook URL",
  "Secret token": "Secret token",
  "This bot is not allowed to join groups yet — turn that on in Zalo Bot Creator.": "Bot này chưa được phép vào nhóm — hãy bật trong Zalo Bot Creator.",
  "Last message failed: {error}": "Tin gần nhất gửi lỗi: {error}",
  "Post event again": "Đăng lại sự kiện",
  "Disconnect group": "Ngắt kết nối nhóm",
  "Change token": "Đổi token",
  "Remove bot": "Gỡ bot",
  "Copy": "Sao chép",
  "Copied": "Đã sao chép",
  "Zalo bot saved": "Đã lưu bot Zalo",
  "Zalo bot removed": "Đã gỡ bot Zalo",
  "Group disconnected": "Đã ngắt kết nối nhóm",
  "Posted to the Zalo group": "Đã đăng vào nhóm Zalo",
  "Zalo bot token (optional)": "Token bot Zalo (không bắt buộc)",
  "The bot announces this event in your runners’ Zalo group. You can also add it later from the event page.": "Bot sẽ thông báo sự kiện vào nhóm Zalo của các runner. Bạn cũng có thể thêm sau trong trang sự kiện.",
  "Zalo bot not saved": "Chưa lưu được bot Zalo",
  "Zalo did not accept this bot token": "Zalo không chấp nhận token bot này",
  "Could not reach Zalo, try again": "Không kết nối được Zalo, thử lại nhé",
  "Connect a Zalo group first": "Hãy kết nối nhóm Zalo trước",
  "Zalo did not deliver the message": "Zalo không gửi được tin nhắn",
  "That does not look like a Zalo bot token": "Đây không giống token bot Zalo",
  "Paste the bot token from Zalo Bot Creator": "Hãy dán token bot từ Zalo Bot Creator",
  "Share the bot’s link in your runners’ Zalo group": "Chia sẻ link bot vào nhóm Zalo của các runner",
  "Use the group invite link Zalo gave you when the bot was created, and confirm “Add bot to group”. The group is connected as soon as Zalo tells us about it.": "Dùng link mời vào nhóm mà Zalo gửi khi tạo bot, rồi xác nhận “Thêm bot vào nhóm”. Nhóm được kết nối ngay khi Zalo báo về hệ thống.",
  "Group connected": "Đã kết nối nhóm",
  "Not connected yet? @mention the bot once": "Chưa kết nối? @nhắc bot một lần",
  "If the group did not get the event introduction, type @, pick the bot and send anything. The first group the bot hears from gets the announcements.": "Nếu nhóm chưa nhận được tin giới thiệu sự kiện, gõ @, chọn tên bot rồi gửi một tin bất kỳ. Nhóm đầu tiên bot nhận được tin sẽ nhận thông báo.",
  "Announcements go to this group. The bot never replies to messages.": "Thông báo được gửi vào nhóm này. Bot không trả lời tin nhắn.",
  "Rookie": "Tân binh",
  "Bronze": "Đồng",
  "Silver": "Bạc",
  "Gold": "Vàng",
  "Platinum": "Bạch kim",
  "Diamond": "Kim cương",
  "Master": "Cao thủ",
  "Legend": "Huyền thoại",
  "Long run": "Chạy dài",
  "Regular": "Chăm chỉ",
  "Conqueror": "Chinh phục",
  "Landlord": "Địa chủ",
  "Raider": "Đột kích",
  "Revenge": "Báo thù",
  "Explorer": "Khám phá",
  "Early bird": "Chim sớm",
  "Night owl": "Cú đêm",
  "Finisher": "Về đích",
  "Podium": "Bục vinh quang",
  "Team champion": "Đội vô địch",
  "Club member": "Thành viên CLB",
  "a half marathon": "một half marathon (21,1 km)",
  "a marathon": "một marathon (42,2 km)",
  "Run {d} in total": "Chạy tổng cộng {d}",
  "Run {d} in one run": "Chạy {d} trong một buổi",
  "Run {n} days in a row": "Chạy {n} ngày liên tiếp",
  "Complete {n} valid runs": "Hoàn thành {n} buổi chạy hợp lệ",
  "Capture {n} sectors": "Chiếm {n} ô",
  "Hold {n} sectors at once": "Giữ {n} ô cùng lúc",
  "Take {n} sectors from other runners": "Cướp {n} ô từ người chơi khác",
  "Take back {n} sectors within 24 h of losing them": "Lấy lại {n} ô trong vòng 24 giờ sau khi bị cướp",
  "Capture {n} different sectors": "Chiếm {n} ô khác nhau",
  "{n} runs of 1 km+ starting before 5 am": "{n} buổi chạy từ 1 km bắt đầu trước 5 giờ sáng",
  "{n} runs of 1 km+ starting after 9 pm": "{n} buổi chạy từ 1 km bắt đầu sau 21 giờ",
  "Qualify in {n} events": "Đủ điều kiện ở {n} sự kiện",
  "Finish in the top 3 of an event": "Vào top 3 một sự kiện",
  "Win an event with your team": "Cùng đội vô địch một sự kiện",
  "Organise an event": "Tổ chức một sự kiện",
  "Join a club": "Tham gia một câu lạc bộ",
  "Now": "Hiện tại",
  "Runners who have it": "Số người chơi đã có",
  "% = share of active runners who have it": "% = tỉ lệ người chơi đang hoạt động đã có huy hiệu này",
  "My badges": "Huy hiệu của tôi",
  "Badges of {name}": "Huy hiệu của {name}",
  "Rank tier": "Bậc hạng",
  "Lv {n}+": "Cấp {n}+",
  "Your rank follows your level: earn XP by running and capturing sectors to climb.": "Bậc hạng đi theo cấp của bạn: chạy và chiếm ô để có XP và lên bậc.",
  "{n} badge tiers unlocked": "Đã mở khóa {n} cấp huy hiệu",
  "Badges": "Huy hiệu",
  "Run to unlock your first badge.": "Chạy để mở khóa huy hiệu đầu tiên.",
  "No badges yet.": "Chưa có huy hiệu nào.",
  "New rank: {rank}": "Lên bậc {rank}",
  "Badge unlocked": "Huy hiệu mới",
  "Badges unlocked": "Huy hiệu mới",
  "Ranks & badges": "Bậc hạng & huy hiệu",
  "You reached a new rank or unlocked a badge.": "Bạn lên bậc mới hoặc mở khóa huy hiệu.",
  "Keep running to climb higher.": "Tiếp tục chạy để lên bậc cao hơn.",
  "🏅 Badge unlocked": "🏅 Mở khóa huy hiệu",
  "🏅 {n} badges unlocked": "🏅 Mở khóa {n} huy hiệu",
  "{who} reached the {rank} rank": "{who} đã lên bậc {rank}",
  "{who} unlocked the {badge} badge": "{who} đã mở khóa huy hiệu {badge}",
  "Only Runner Wars can create events right now": "Hiện chỉ Runner Wars mới tạo được giải đấu",
  "You can still join events and organise the ones you are an organiser of.": "Bạn vẫn tham gia được các giải và quản lý giải mà bạn là ban tổ chức.",
  "See events": "Xem các giải",
  "New events from Runner Wars will show up here.": "Giải đấu mới của Runner Wars sẽ xuất hiện ở đây.",
  "Not approved": "Không được duyệt",
  "You have used your {n} free events": "Bạn đã dùng hết {n} giải được tạo miễn duyệt",
  "This one will be sent to Runner Wars for approval. Only you can see it until it is approved.": "Giải này sẽ được gửi Runner Wars duyệt. Chỉ bạn thấy giải cho đến khi được duyệt.",
  "Send for approval": "Gửi yêu cầu duyệt",
  "Sent for approval": "Đã gửi yêu cầu duyệt",
  "You'll be notified when Runner Wars approves it.": "Bạn sẽ nhận thông báo khi Runner Wars duyệt giải.",
  "Waiting for Runner Wars to approve this event": "Giải đang chờ Runner Wars duyệt",
  "Only you can see it for now. You can still edit it; runners can join once it is approved.": "Hiện chỉ bạn thấy giải. Bạn vẫn sửa được; runner tham gia được sau khi giải được duyệt.",
  "Runner Wars did not approve this event": "Runner Wars không duyệt giải này",
  "{name} wants to run {event}": "{name} xin tổ chức giải {event}",
  "Open Admin → Events to approve or decline.": "Mở Admin → Events để duyệt hoặc từ chối.",
  "✅ {name} was approved": "✅ Giải {name} đã được duyệt",
  "{name} was not approved": "Giải {name} không được duyệt",
  "What the bot posts": "Bot đăng những gì",
  "Switch off what your group does not need. The introduction and “Post event again” always go out.": "Tắt những tin nhóm không cần để tránh spam. Tin giới thiệu giải và nút “Đăng lại sự kiện” luôn hoạt động.",
  "Event start": "Giải bắt đầu",
  "Once, when runs start counting, with the rules.": "Một lần khi giải bắt đầu tính, kèm thể lệ.",
  "Results": "Kết quả",
  "The winners when the event ends, or a cancellation.": "Người thắng khi giải kết thúc, hoặc khi giải bị huỷ.",
  "New teams": "Đội mới",
  "Each team the organisers add.": "Mỗi đội ban tổ chức thêm vào.",
  "Runners joining": "Runner tham gia",
  "Each runner who joins or changes team.": "Mỗi runner tham gia hoặc đổi đội.",
  "Every counted run": "Từng buổi chạy",
  "One message per run — the busiest kind.": "Mỗi buổi chạy được tính là một tin — loại nhiều tin nhất.",
  "Sponsored": "Tài trợ",
  "Sponsored sector": "Ô tài trợ",
  "Until {date}": "Đến {date}",
  "+{xp} XP the first time you capture it during this campaign.": "+{xp} XP lần đầu bạn chiếm ô này khi chiến dịch còn diễn ra.",
  "Visit {name} ↗": "Xem {name} ↗",
  "Sponsored sector {key} · {brand}": "Ô tài trợ {key} · {brand}",
  "My offers": "Ưu đãi của tôi",
  "Gifts from sponsors: capture their sectors on the map or finish the events they sponsor.": "Quà từ nhà tài trợ: chiếm ô tài trợ trên bản đồ hoặc hoàn thành các giải họ tài trợ.",
  "No offers yet": "Chưa có ưu đãi",
  "Sponsored sectors and events show their gifts. Run to earn one!": "Ô tài trợ và giải được tài trợ có quà. Chạy để nhận nhé!",
  "Code copied": "Đã chép mã",
  "Expired {date}": "Hết hạn {date}",
  "Valid until {date}": "Dùng đến {date}",
  "Used": "Đã dùng",
  "Share this run": "Chia sẻ buổi chạy",
  "Share run": "Chia sẻ buổi chạy",
  "Share or save to Photos": "Chia sẻ hoặc lưu vào Ảnh",
  "On iPhone: tap Share, then “Save Image” to keep it in Photos.": "Trên iPhone: bấm Chia sẻ rồi chọn “Lưu hình ảnh” để lưu vào Ảnh.",
  "Download image": "Tải ảnh về",
  "Could not share the image": "Không chia sẻ được ảnh",
  "Could not create the image": "Không tạo được ảnh",
  "runnerwars.com · Run to conquer your city": "runnerwars.com · Chạy để chiếm thành phố",
};
